import { createContext } from "react";
const FaqsContext = createContext({});
export default FaqsContext;
